// Single source of truth for commodity measurement units (CONTRACT.md "Unit
// mapping"). Every place that renders a unit must go through this helper —
// never hard-code "KWh" (or any unit) at a call site.
export const COMMODITY_UNITS = Object.freeze({
  WATER: "L",
  ELECTRICITY: "kWh",
  GAS: "kg",
});

const normalizeCommodity = (commodity) =>
  String(commodity || "").trim().toUpperCase();

// Returns the display unit for a commodity. A server-provided unit (quote /
// payment record / commodityUnits) is preferred, except when it is
// obviously wrong for the commodity (water must never read as a kWh unit).
export const commodityUnit = (commodity, serverUnit) => {
  const key = normalizeCommodity(commodity);
  const fallback = COMMODITY_UNITS[key] || "";
  const candidate = typeof serverUnit === "string" ? serverUnit.trim().replace(/^\//, "") : "";
  if (!candidate) return fallback;
  if (key === "WATER" && /kwh/i.test(candidate)) return fallback;
  return candidate;
};

// Picks the unit from an estate's `commodityUnits` map ({water, electricity, gas}).
export const estateCommodityUnit = (commodityUnits, commodity) =>
  commodityUnit(commodity, commodityUnits?.[String(commodity || "").toLowerCase()]);

export const formatQuantity = (value, commodity, serverUnit) => {
  const n = Number(value);
  const unit = commodityUnit(commodity, serverUnit);
  return `${Number.isFinite(n) ? n.toLocaleString(undefined, { maximumFractionDigits: 2 }) : "0"}${unit ? ` ${unit}` : ""}`;
};
